import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgsDatePipe } from './pgs-date.pipe';


@NgModule({
  declarations: [
    PgsDatePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PgsDatePipe
  ]
})
export class PgsDateModule { }
